import { render, staticRenderFns } from "./FactorListPop.vue?vue&type=template&id=632f88ba"
import script from "./FactorListPop.vue?vue&type=script&lang=js"
export * from "./FactorListPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632f88ba')) {
      api.createRecord('632f88ba', component.options)
    } else {
      api.reload('632f88ba', component.options)
    }
    module.hot.accept("./FactorListPop.vue?vue&type=template&id=632f88ba", function () {
      api.rerender('632f88ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/popup/FactorListPop.vue"
export default component.exports